import React from "react";
import { CustomModal } from "./styles";
import {
  Container,
  Header,
  Title,
  Subtitle,
  Section,
  SectionTitle,
  Table,
} from "./ExhibitLayout";

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const ModalExhibit1 = ({ initialDemand, demandGrowthRate, goBack }) => (
  <CustomModal goBack={goBack}>
    <Container>
      <Header>
        <Title>Exhibit 1: Unmet Demand & Growth Projections</Title>
        <Subtitle>Year 1 baseline demand and projected annual growth for each segment.</Subtitle>
      </Header>

      <Section>
        <SectionTitle>Year 1 Annual Unmet Demand</SectionTitle>
        <Table>
          <thead>
            <tr>
              <th>Segment</th>
              <th>Unmet Demand</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><b>Mobile</b></td>
              <td className="numeric">{numberWithCommas(initialDemand.mobile)} units</td>
            </tr>
            <tr>
              <td><b>Auto</b></td>
              <td className="numeric">{numberWithCommas(initialDemand.auto)} units</td>
            </tr>
          </tbody>
        </Table>
      </Section>

      <Section>
        <SectionTitle>Expected Annual Growth</SectionTitle>
        <Table>
          <thead>
            <tr>
              <th>Year</th>
              <th>Mobile Segment</th>
              <th>Auto Segment</th>
            </tr>
          </thead>
          <tbody>
            {demandGrowthRate
              .filter(row => row.round_number + 1 <= 3)
              .map(row => (
                <tr key={row.id}>
                  <td><b>Year {row.round_number + 1}</b></td>
                  <td className="numeric">{row.mobile * 100}%</td>
                  <td className="numeric">{row.auto * 100}%</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Section>
    </Container>
  </CustomModal>
);

export default ModalExhibit1;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit1.js